import React from "react";
import { Empty, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { SearchOutlined, FileAddOutlined } from "@ant-design/icons"; // Icons from Ant Design
import "./Components.css"; // Custom CSS for styling

const EmptyJobs = () => {
  const navigate = useNavigate();
  //const onCreateJob = navigate("/jobs/job-admin/job-posts/create-job");

  return (
    <div className="empty-jobs-container">
      <Empty
        image={<SearchOutlined style={{ fontSize: 60, color: "#08839b" }} />}
        description={
          <span>
            <strong>No Jobs Available</strong>
            <br />
            You currently have no job posts. Let's create one!
          </span>
        }
      >
        {/* Button to create a new job */}
        <Button
          type="primary"
          icon={<FileAddOutlined />}
          //onClick={onCreateJob}
          size="large"
          onClick={() => navigate("/jobs/job-admin/job-posts/create-job")}
        >
          Create New Job
        </Button>
      </Empty>
    </div>
  );
};

export default EmptyJobs;
